<template>
  <SplitViewTemplate
    :screenConfig="data"
    :backButtonRoute="'/settings/sales'"
    :dataModel="formModel"
    :formConfig="setFormConfig"
    :setLoading="setLoading"
    :validationSummary="validationSummary"
  />
</template>
<script>
import SplitViewTemplate from "../../../templates/split-view";
import RouteMixin from "@/_mixins/route.mixin";
import { SplitViewService } from "../../../_services/api/templates/split-view.services";
import { SalesOrderService } from "../../../_services/api/sales/sales-order.service";

export default {
  mixins: [RouteMixin],
  components: {
    SplitViewTemplate,
  },
  data() {
    return {
      setLoading: false,
      validationSummary: [],
      formModel: {
        RecordId: "00000000-0000-0000-0000-000000000000",
        Code: "",
        Description: "",
        CreatedBy: "",
        DateCreated: "",
        ChangedBy: "",
        DateChanged: "",

        IsDefault: "Y",
        IsDefaultData: false,
        SetDefault: true,
        Inactive: true,
        Status: "A",

        CommentLabel1: "",
        CommentLabel2: "",
        CommentLabel3: "",
        CommentLabel4: "",
        CommentLabel5: "",
        CommentLabel6: "",
        CommentLabel7: "",
        CommentLabel8: "",
        CommentLabel9: "",
        CommentLabel10: "",
        CommentLabel11: "",
        CommentLabel12: "",
        CommentLabel13: "",
        CommentLabel14: "",
        CommentLabel15: "",
        CommentLabel16: "",
        CommentLabel17: "",
        CommentLabel18: "",
        CommentLabel19: "",
        CommentLabel20: "",
        CommentRequired1: false,
        CommentRequired2: false,
        CommentRequired3: false,
        CommentRequired4: false,
        CommentRequired5: false,
        CommentRequired6: false,
        CommentRequired7: false,
        CommentRequired8: false,
        CommentRequired9: false,
        CommentRequired10: false,
        CommentRequired11: false,
        CommentRequired12: false,
        CommentRequired13: false,
        CommentRequired14: false,
        CommentRequired15: false,
        CommentRequired16: false,
        CommentRequired17: false,
        CommentRequired18: false,
        CommentRequired19: false,
        CommentRequired20: false,
      },
      data: {
        title: "Sales Order Type",
        pageRoute: "/sales-order-types",
        saveEndPoint: "SalesOrderType",
        recordEndPoint: "SalesOrderType",
        updateEndPoint: "SalesOrderType",
        updateKeyField: "Code",
        updateKeyFieldType: "string",
        isDefaultEndPoint: "Save_DefaultSalesOrderType",
        exportFileName: "Sales Order Type",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "SalesOrderType",
              filter: "",
              select: [
                "Code",
                "Description",
                "ChangedBy",
                "Status",
                "Inactive",
                "IsDefault",
              ],
              sort: [{ selector: "Code", desc: false }],
              serverPaging: true,
              allowGrouping: false,
            },
            rowSelect: {
              view: this,
              page: "sales-order-types",
              mode: "review",
              idProperty: "Code",
            },
          },

          toolbar: {
            search: true,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/sales-order-types/create",
                clickAction: {},
                buttonLocation: "left",
              },
            ],
          },
          columns: [
            {
              screenField: "OrderType",
              dataField: "Code",
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "Description",
                  },
                ],
                secondary: [
                  {
                    dataField: "Code",
                  },
                ],
              },
              allowSearch: false,
              allowHiding: false,
              label: "Type",
              exportFields: [
                {
                  dataField: "Code",
                  label: "SO Type Code",
                },
                {
                  dataField: "Description",
                  label: "SO Type Description",
                },
              ],
            },
            {
              dataField: "ChangedBy",
              caption: "Changed By",
            },
            {
              screenField: "IsDefault",
              makeDisabled: (data) => {
                return (
                  data.column.dataField == "IsDefault" &&
                  data.data.Inactive == "Y"
                );
              },
            },
            {
              screenField: "Status",
              width: "auto",
              filterIndex: "0",
            },
          ],
          valueChangedEventListners: [
            {
              dataField: "IsDefault",
              listner: async (event, cellInfo, grid, updateIsDefault) => {
                var items = grid.getDataSource().items();
                var getDefault,
                  clickedDefault = undefined;
                if (items)
                  items.forEach((element) => {
                    if (element.Code == cellInfo.data.Code)
                      clickedDefault = element.Code;
                    if (element.IsDefault == "Y") getDefault = element.Code;
                  });
                if (!getDefault)
                  await SplitViewService.getIsDefault("SalesOrderType").then(
                    (res) => {
                      if (res.data.value.length > 0)
                        getDefault = res.data.value[0].Code;
                    }
                  );
                let confirmLeaving = await this.$confirm(
                  `Do you want to change the default setting from ${getDefault} to ${clickedDefault} ?`,
                  "Default Setting Change"
                );
                if (!confirmLeaving) {
                  event.component.beginUpdate();
                  event.component.option("value", false);
                  event.component.endUpdate();
                  return;
                }
                if (updateIsDefault) {
                  this.$store.dispatch("ui/setUpdateIsDefault", {
                    update: true,
                    code: cellInfo.data.Code,
                    event: event,
                  });
                }
              },
            },
          ],
        },
        recordPostProcess: this.recordPostProcess,
      },
      labelFormItems: [],
    };
  },
  created() {
    for (let index = 1; index < 21; index++) {
      this.labelFormItems.push({
        dataField: "CommentLabel" + index,
        label: { text: "Label " + index },
        editorType: "dxTextBox",
        editorOptions: {
          maxLength: 40,
          value: this.baseView.mode == "create" ? "" : undefined,
        },
      });
      this.labelFormItems.push({
        dataField: "CommentRequired" + index,
        label: { visible: false },
        editorType: "dxCheckBox",
        cssClass: "check-box-field",
        editorOptions: {
          cssClass: "check-box-field",
          value: this.baseView.mode == "create" ? false : undefined,
        },
      });
    }
  },
  computed: {
    setDefaultEdit() {
      return this.formModel["IsDefaultData"] || !this.formModel["Inactive"];
    },
    setActiveReadOnly() {
      return this.formModel["SetDefault"] ? true : false;
    },
    setFormConfig() {
      const form = {
        headerToolbar: {
          closeSplit: true,
          save: true,
          audit: true,
          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateCreated",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
              ],
            },
          ],
          toolbarFormItems: [
            {
              screenField: "Inactive",
              editorType: "dxSwitch",
              editorOptions: {
                readOnly: this.setActiveReadOnly,
                onValueChanged: (e) => {
                  this.onActiveValueChanged(e);
                },
              },
              cssClass: "toolbar-customer-label",
            },
          ],
          toolbarFormLocation: "after",
        },
        formItems: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                screenField: "Code",
                dataField: "Code",
                editorOptions: {
                  maxLength: 2,
                },
                required: true,
                isPrimaryKeyField: true,
                label: { text: "Type" },
                visible: true,
                allowUpdate: this.baseView.mode == "create",
              },
              {
                screenField: "Code",
                dataField: "Description",
                label: { text: "Description" },
                required: true,
                allowUpdate: this.baseView.mode !== "review",
                isPrimaryKeyField: true,
              },
              {
                dataField: "SetDefault",
                editorOptions: {
                  readOnly: this.setDefaultEdit,
                },
                screenField: "IsDefault",
              },
              {
                itemType: "group",
                caption: "",
                colCount: 2,
                cssClass: "label-section",
                items: this.getLabelFieldItems,
              },
            ],
          },
        ],
        overWritePayload: this.overWritePayload,
      };

      return form;
    },
    getLabelFieldItems() {
      return this.labelFormItems;
    },
  },
  methods: {
    async onActiveValueChanged(e) {
      if (
        this.baseView.mode == "edit" &&
        e.value == false &&
        e.previousValue == true
      ) {
        this.setLoading = true;
        SalesOrderService.getSalesOrderItem({
          filter: `SalesOrderTypeCode eq '${this.baseView.id}'`,
          select: ["Code", "SalesOrderTypeCode"],
        })
          .then((res) => {
            this.setLoading = false;

            if (res.data.value.length > 0) {
              this.formModel.Inactive = true;

              e.component.beginUpdate();
              e.component.option("value", true);
              e.component.endUpdate();

              this.validationSummary = [];
              this.validationSummary.push({
                message: `${this.formModel.Description} is associated with sales order records. This may not be marked inactive until it is no longer associated with sales order records.`,
              });
              this.validationSummary.push({
                message: `Tip: To identify the associated sales orders use the filters on the sales order list.`,
              });
            }
          })
          .catch((err) => {
            if (err) this.setLoading = false;
          });
      }
    },
    overWritePayload(payload) {
      if (this.baseView.mode == "create") {
        payload.Status = "A";
        payload.RecordId = "00000000-0000-0000-0000-000000000000";
      }

      for (const property in payload) {
        if (typeof payload[property] == "boolean") {
          if (payload[property]) payload[property] = "Y";
          else payload[property] = "N";
        }

        if (this.baseView.mode == "create")
          if (property.startsWith("CommentLabel")) {
            if (!payload[property]) payload[property] = "";
          }
      }
      return payload;
    },
    recordPostProcess(data) {
      for (const property in data) {
        if (property.startsWith("CommentRequired")) {
          if (data[property] == "Y") data[property] = true;
          else data[property] = false;
        }
      }

      return data;
    },
  },
};
</script>

<style lang="scss">
.label-section {
  .dx-item-content.dx-box-item-content.dx-box-flex.dx-box.dx-widget {
    > div:last-child {
      max-width: 50px;
      > .dx-item-content {
        justify-content: center;
        align-items: center;
        .check-box-field {
          padding: unset !important;
        }
      }
    }
  }
}
</style>
